<h3 class="display-10">{{ 'store.invitation.locationTitle' | translate }}</h3>

<form [formGroup]="registerForm">
  <div class="form-group mb-4">
    <div class="form-group mb-4">
      <header class="header-input-filed ">{{ 'store.settings.country' | translate }}</header>
      <select [ngClass]="{ 'is-invalid': submitted && f?.country?.errors }" formControlName="country"
              class="select-category" name="cars" id="cars">
        <option *ngFor="let item of countriesList" [value]="item.id">
          {{item?.name}}
        </option>
      </select>
      <div *ngIf="submitted && f?.country?.errors" class="invalid-feedback">
        <div *ngIf="f.country.errors.required">{{ 'store.invitation.countryRequired' | translate }}</div>
      </div>
      <header class="header-input-filed ">{{ 'store.settings.posLocation' | translate }}</header>
      <input type="text" [value]="address" class="form-control" (keydown.enter)="$event.preventDefault()" id="serach"
             [placeholder]="'store.settings.searchLocation' | translate" autocorrect="off" autocapitalize="off" spellcheck="off" #search>
      <div class="map-container">
        <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
          <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                      (dragEnd)="markerDragEnd($event)"></agm-marker>
        </agm-map>
      </div>
      <!--    <div *ngIf="submitted && f.country.errors"  class="invalid-feedback">-->
      <!--      <div *ngIf="f.country.errors.required">Location Is required</div>-->
      <!--    </div>-->
    </div>
  </div>
  <div class="btns-container">
    <a class="a-padding" (click)="onSubmit(true)">{{ 'common.back' | translate }}</a>
    <button (click)="onSubmit()" class="btn btn-primary">{{ 'store.invitation.createStore' | translate }}</button>
  </div>
</form>
